export default "__VITE_ASSET__T32WVAoM__"